import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useGetComposeAddressDetails() {
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getAddressDetails = guid => {
    setLoading(true);
    axiosClient
      .get(`/InventoryAddress/Recomposse?guid=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setDetails(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, details, getAddressDetails];
}
